import React, { useState, useEffect } from 'react';
import { WifiOff, X } from 'lucide-react';

export function OfflineIndicator() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const goOffline = () => { setIsOffline(true); setDismissed(false); };
    const goOnline = () => setIsOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline || dismissed) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium shadow-lg"
      style={{ animation: 'slideDown .3s ease-out' }}
      data-testid="offline-indicator"
    >
      <WifiOff className="w-4 h-4 shrink-0" />
      <span>You&apos;re offline — showing cached content</span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-2 p-0.5 hover:bg-amber-600 rounded transition-colors"
        data-testid="offline-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
